export class QFilterModel {
  public group_type: string;
  public start_date: string;
  public end_date: string;

  public groups: string[]; // groups as string list
  public groupIndexes: number[];
  public clusters: number[]; // clusters
  public stores: number[]; // stores as numeric list
  public card_mode: string;
  public area: string;

  public promo: number;
  public product_level: string;
  public product_code: any[];

  public key_code_group: string;
  public key_desc_group: string;

  public storeListSet: string[]; // stores as string list // NOT USED!!!
}



// WEBPACK FOOTER //
// ./src/app/models/qfilter.model.ts